import router from "./router";
import { MessageBox } from 'element-ui'
import Axios from "./Axios";
import store from "./store";

// 路由权限配置
const routePermissions = {
  // 白名单路由（无需登录）
  public: ['Home', 'search', 'help', 'Login', 'information', 'download', 'lookSpecialty', 'NewsList', 'Detail', 'lookCollege', 'Recommend', 'server', 'vip', 'art_detail', 'art_solution'],
  
  // 普通用户路由（已登录即可访问）
  user: ['info', 'specialtyInfo', 'CollegeInfo', 'schoolNews', 'solution', 'provinceLine', 'ranking', 'lookData', 'myAssess', 'myCard', 'ChangePwd', 'goodsInfo', 'chooseSpecialty'],
  
  // VIP用户路由
  vip: ['info', 'specialtyInfo', 'CollegeInfo', 'specialty', 'schoolNews', 'solution', 'provinceLine', 'ranking', 'lookData', 'myAssess', 'myCard',  'ChangePwd', 'CollegeFirst', 'MajorFirst', 'ReportTable', 'escort', 'goodsInfo', 'collegeScoreLine', 'SpecialtyScore', 'getPlan', 'otherBatch', 'otherBatchScore', 'newChooseSubject', 'newSpecialtySearch', 'chooseSpecialty', 'newSubjectUser', 'analyse', 'advanceBatch', 'strong_base', 'score', 'score-other', 'hld', 'hldResult', 'chat']
};

// 用户等级枚举
const UserVipLevel = {
  NONE: 0,
  VIP: 1
};

// 获取用户信息并存储到store
const initUserInfo = async () => {
  const token = localStorage.getItem('TOKEN');
  if (!token) return;
  
  try {
    const res = await Axios.post('user_info/getUserInfo');
    if (res) {
      store.commit('setInfo', res);
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
    // 可选：token失效，清除本地token
    // localStorage.removeItem('TOKEN');
  }
};

// 显示提示对话框
const showConfirmDialog = (message, confirmText, onConfirm) => {
  MessageBox.confirm(message, '提示', {
    center: true,
    confirmButtonText: confirmText,
    callback: action => {
      if (action === 'confirm') {
        onConfirm();
      }
    }
  });
};

// 检查用户权限
const checkUserPermission = (routeName, userInfo) => {
  const { is_wenli: hasWenli, is_vip: vipLevel } = userInfo;
  
  // 检查是否填写文理科信息
  if (!hasWenli && routeName !== 'information') {
    return { hasPermission: false, redirect: 'information' };
  }
  
  // 根据VIP等级检查权限
  switch (vipLevel) {
    case UserVipLevel.NONE:
      return {
        hasPermission: routePermissions.user.includes(routeName),
        needUpgrade: !routePermissions.user.includes(routeName)
      };
    case UserVipLevel.VIP:
      return {
        hasPermission: routePermissions.vip.includes(routeName),
        needUpgrade: false
      };
    default:
      return { hasPermission: false, needUpgrade: false };
  }
};

// 初始化用户信息
initUserInfo();

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('TOKEN');
  const routeName = to.name;
  
  // 处理空路由名，重定向到首页
  if (!routeName) {
    next('/');
    return;
  }
  
  // 白名单路由，直接放行
  if (routePermissions.public.includes(routeName)) {
    next();
    return;
  }
  
  // 需要登录的路由
  if (!token) {
    showConfirmDialog('该功能仅注册用户可用！', '注册', () => {
      router.push('/Login');
    });
    return;
  }
  
  // 获取用户信息
  const userInfo = store.state.userInfo;
  if (!userInfo || Object.keys(userInfo).length === 0) {
    // 用户信息未加载完成，等待一下再重试
    next({ ...to, replace: true });
    return;
  }
  
  // 检查权限
  const { hasPermission, needUpgrade, redirect } = checkUserPermission(routeName, userInfo);
  
  // 需要重定向到信息完善页
  if (redirect) {
    next(`/${redirect}?redirect=${to.path}`);
    return;
  }
  
  // 有权限，直接放行
  if (hasPermission) {
    next();
    return;
  }
  
  // VIP升级提示
  if (needUpgrade) {
    showConfirmDialog('该功能仅VIP用户可用！', '开通VIP', () => {
      router.push('/vip');
    });
    return;
  }
  
  // 默认情况，无权限访问
  next('/');
});